/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type DtmKadDocsCancelPartialUpdateRequest = {} | null | undefined;
export type DtmKadDocsCancelPartialUpdateResponse = any;

export type DtmKadDocsCancelPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/dtm_kad_docs/{id}/cancel/
 *
 * ```yaml
 * operationId: dtm_kad_docs_cancel_partial_update
 * tags:
 *   - dtm_kad_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const dtmKadDocsCancelPartialUpdateOperation = ({
  id,
  ...rest
}: DtmKadDocsCancelPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/dtm_kad_docs/${id}/cancel/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/dtm_kad_docs/{id}/cancel/' };
  };

/**
 * PATCH /dmx-server/dtm_kad_docs/{id}/cancel/
 *
 * ```yaml
 * operationId: dtm_kad_docs_cancel_partial_update
 * tags:
 *   - dtm_kad_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const dtmKadDocsCancelPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DtmKadDocsCancelPartialUpdateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = dtmKadDocsCancelPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
